import { render } from "./ThePaymentsList.vue?vue&type=template&id=afe12d34"
import script from "./ThePaymentsList.vue?vue&type=script&lang=js"
export * from "./ThePaymentsList.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__